var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ3AscentDescentSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v4H47.83L34.48 73.92l-2.11-3.73L46.68 59H69zm-20-9l12-13H51V8h-4v29H37l12 13zm-24 0h4V21h10L27 8 15 21h10v29zM7 63h24v-4H7v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J3_Ascent_descent_switch.6fddd168.svg";
export { SvgJ3AscentDescentSwitch as ReactComponent };